import React from 'react';
import { observer } from 'mobx-react';
import { ShowPackageTypeTag } from './ShowPackageTypeTag';
import { IGetApiType } from '../../../REST';
import { useTariffPackageInstanceItem } from '../../../hooks';
import { dateText2Text, dateText2Utc } from '../../../instruments';
import {
    CardInfoToolBar,
    CardMainLayout,
    Catcher,
    FieldInfo,
    IconBool,
    LinkComponent,
    cardLayoutOptions,
} from '../../../Components';
import Styles from '../../MonthlyOrders/m_styles.less';

export const ShowTariffPackageInstanceInfo: React.FC = observer(() => {
    const {
        id,
        cardId,
        cardSet,
        company,
        createdAt,
        endDate,
        nonExpirable,
        outOfBundle,
        packageType,
        renewable,
        startDate,
        tariffPackage,
    } = useTariffPackageInstanceItem();
    const loadingTypes: IGetApiType[] = ['GET_TARIFF_PACKAGE_INSTANCE'];

    return (
        <Catcher>
            <CardMainLayout idSpinners={loadingTypes} name={`# ${id}`} columnOption={cardLayoutOptions.cardInfo}>
                <FieldInfo title={'Company'} dataTest="ariffPackageInstanceInfoCompany">
                    <LinkComponent currentListComponent={'CompaniesList'} id={company?.id} name={company?.name} />
                </FieldInfo>
                <FieldInfo title={'Card Set'} dataTest="ariffPackageInstanceInfoCardSet">
                    <LinkComponent currentListComponent={'CardSetsList'} id={cardSet?.id} name={cardSet?.name} />
                </FieldInfo>
                <FieldInfo title={'Card'} dataTest="ariffPackageInstanceInfoCard">
                    <LinkComponent currentListComponent={'CardList'} id={cardId} />
                </FieldInfo>
                <FieldInfo title={'Period'} dataTest="ariffPackageInstanceInfoPeriod">
                    {`${dateText2Text(startDate)} - ${dateText2Text(endDate)}`}
                </FieldInfo>
                <FieldInfo title={'Package Type'} dataTest="ariffPackageInstanceInfoPackageType">
                    <ShowPackageTypeTag value={packageType} />
                </FieldInfo>
                <FieldInfo title={'Non-Expirable'} dataTest="ariffPackageInstanceInfoNon-Expirable">
                    <IconBool value={nonExpirable} />
                </FieldInfo>
                <FieldInfo title={'Out of Bundle'} dataTest="ariffPackageInstanceInfoOutOfBundle">
                    <IconBool value={outOfBundle} />
                </FieldInfo>
                <FieldInfo title={'Renewable'} dataTest="ariffPackageInstanceInfoRenewable">
                    <IconBool value={renewable} />
                </FieldInfo>
                <FieldInfo title={'Created at'} dataTest="ariffPackageInstanceInfoCreatedAt">
                    {dateText2Utc(createdAt)}
                </FieldInfo>
                <FieldInfo title={'Packages'} dataTest="ariffPackageInstanceInfoPackages">
                    <LinkComponent
                        currentListComponent={'PackagesSell'}
                        id={tariffPackage?.id}
                        name={tariffPackage?.name}
                    />
                </FieldInfo>
                <div className={Styles.fieldMargin}>
                    <FieldInfo title={'Network'} dataTest="ariffPackageInstanceInfoNetwork">
                        {tariffPackage?.networks?.map((n, i) => (
                            <LinkComponent
                                currentListComponent={'OperatorsList'}
                                id={n.id}
                                key={`${n}-${i}`}
                                name={`${n.name || '# ' + n.id.toString()} ${
                                    n?.country?.name ? ' (' + n.country.name + ')' : ''
                                }`}
                            />
                        ))}
                    </FieldInfo>
                    <FieldInfo title={'Operator'} dataTest="ariffPackageInstanceInfoOperator">
                        {tariffPackage?.operators?.map((n, i) => (
                            <LinkComponent
                                currentListComponent={'OperatorsList'}
                                id={n?.id}
                                key={`${n}-${i}`}
                                name={n?.name}
                            />
                        ))}
                    </FieldInfo>
                </div>

                <CardInfoToolBar dataTest="ShowTariffPackageInstanceInfo" loadingTypes={loadingTypes} />
            </CardMainLayout>
        </Catcher>
    );
});
